module.exports = __webpack_public_path__ + "img/government-page-overlay.fe5b5b98.png";